export type EmployeeListRow = { id: string; first_name: string; last_name: string };

/** GET /api/employees liefert `{ items: [...] }`, nicht ein flaches Array. */
export function parseEmployeesListResponse(data: unknown): EmployeeListRow[] {
  const rows = Array.isArray(data)
    ? data
    : Array.isArray((data as { items?: unknown })?.items)
      ? ((data as { items: unknown[] }).items ?? [])
      : [];
  return rows
    .map((e) => {
      const row = e as { id?: string; first_name?: string; last_name?: string };
      return {
        id: String(row.id ?? ''),
        first_name: String(row.first_name ?? ''),
        last_name: String(row.last_name ?? ''),
      };
    })
    .filter((e) => e.id.length > 0);
}
